"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var insertCss = require("isomorphic-style-loader/lib/insertCss");
var withStyles_1 = require("isomorphic-style-loader/lib/withStyles");
function $withStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    var prefix = 'ANONYMOUS_CSS_';
    styles = styles.map(function (style) {
        var type = style.constructor.name;
        if (type === 'String') {
            var content_1 = [[uniqueId(prefix), style, '']];
            return {
                _getContent: function () { return content_1; },
                _getCss: function () { return style; },
                _insertCss: function () { return insertCss(content_1); }
            };
        }
        return style;
    });
    return withStyles_1.default.apply(void 0, styles);
}
exports.withStyles = $withStyles;
var id = 0;
function uniqueId(prefix) {
    return prefix + ++id;
}
//# sourceMappingURL=withStyles.js.map